<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <vs-card style="border-radius: 10px;">
          <div slot="header">
            <h3 class="card-title mb-0">Búsqueda de empresa</h3>
          </div>
          <vs-row>
            <vs-col vs-lg="8" vs-xs="8" vs-sm="8">
              <CompanySelector v-model="company"/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="4" vs-sm="4">
              <div class="d-flex ">
                <vs-button icon="add" color="primary" class="flex-shrink-0 ml-auto"
                           style="margin-top: 1.5rem;" :disabled="activateButton" @click="newTariff()">Agregar
                  tarifa
                </vs-button>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>

        <vs-card style="border-radius: 10px;" v-if="showNewRate">
          <vs-row>
            <vs-col vs-lg="8" vs-xs="8" vs-sm="8">
              <h3 class="card-title">{{ titleRate }}</h3>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="4" vs-sm="4">
              <div class="d-flex pr-4">
                <vs-button color="rgb(255,186,0)" class="flex-shrink-0 ml-auto mb-0 mt-0"
                           style="margin-top: 1.5rem;" @click="cancel()">Cancelar
                </vs-button>
              </div>
            </vs-col>
          </vs-row>
          <FormRate
              v-bind:company=company
              v-bind:rate="selectedRate"
              v-bind:newRate="newRate"
              v-on:updateRates="getTariffs"
              v-on:removeStyle="removeStyle"
              v-bind:type-day-out="unityDayOut"/>
        </vs-card>

        <vs-card style="border-radius: 10px;" v-if="company">
          <vs-table id="rate" ref="rate" stripe pagination max-items="10" search :data="listRates"
                    class="text-nowrap" noDataText="No se encontraron tarifas">
            <template slot="thead">
              <vs-th sort-key="id">Código</vs-th>
              <vs-th sort-key="title">Nombre</vs-th>
              <vs-th sort-key="vehicleType">Tipo de <br> vehículo</vs-th>
              <vs-th sort-key="graceTime">Gracia de entrada<br>Gracia de salida</vs-th>
              <vs-th sort-key="taxes">Impuestos</vs-th>
              <vs-th sort-key="lostTicket">Valor tiquete <br> perdido</vs-th>
              <vs-th sort-key="actions">Acciones</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id" style="width: 100px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div>
                    <span class=" badge-pill ">{{ data[indextr].id }}</span>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].title" style="width: 200px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div>
                    <h5 class="mb-0 font-16">
                      {{ data[indextr].title }}
                    </h5>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].itemType" style="width: 80px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div>
                    <div class>
                      <h5 class="mb-0 font-16">
                        {{ findVehicleType(data[indextr].itemType) }}
                      </h5>
                    </div>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].graceTime" style="width: 100px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div class="d-flex no-block align-items-center">
                    <div class>
                      <h6 class="mb-0 font-16">
                        <span class="text-muted">Entrada:</span>
                        {{ data[indextr].graceLiquidation }}
                      </h6>
                      <h6 class="mb-0 font-16">
                        <span class="text-muted">Salida:</span>
                        {{ data[indextr].graceTime }}
                      </h6>
                    </div>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].taxes" style="width: 80px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div class="d-flex no-block align-items-center">
                    <div class>
                      <h5 class="mb-0 font-16">
                        {{ data[indextr].taxes == "Y" ? "19%" : "0%" }}
                      </h5>
                      <span class="text-muted">{{
                          data[indextr].taxesMode == "D" ? "Deducir" : "Agregar"
                        }}</span>
                    </div>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].lostTicket" style="width: 80px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div class="d-flex align-items-center">
                    <span>{{ formatPrice(data[indextr].lostTicket) }}</span>
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].actions" style="width: 150px;"
                       :class="{ 'chosen': selectedRate != null && selectedRate.code === data[indextr].code }">
                  <div class="d-flex align-items-center">
                    <vs-button color="danger" type="filled" icon="delete" @click="remove(data[indextr])"
                               style="margin-right: 5px;"></vs-button>
                    <vs-button color="primary" type="filled" icon="edit"
                               @click="edit(data[indextr])"></vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<style>
.circulo {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.chosen {
  background-color: #b6e9fd;
}
</style>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
import FormRate from "./form-rate";
import CompanySelector from "@/components/Shared/CompanySelector";
import {confirmation, formatPrice} from "@/global/utils";
import {configToast, TOAST_TYPES} from "@/global/toast";
import {ROUTES} from "@/global/api_routes";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import {tariffTypes} from "@/global/constants";
import toast from "@/global/ToastConfig";

export default {
  name: "CurrentRates",
  components: {
    Treeselect,
    FormRate,
    CompanySelector
  },

  data: () => ({
    activePrompt: false,
    isLoading: false,
    company: null,
    companies: [],
    listRates: [],
    activateButton: true,
    showNewRate: false,
    vehicleType: null,
    itemsType: [],
    selectedRate: null,
    titleRate: "Registrar tarifa",
    newRate: false,
    unityDayOut: null,
  }),
  watch: {
    company: function () {
      this.getTariffs();
      this.activateButton = false;
      this.getItemsType();
    },
  },
  mounted() {
    this.getDayOutUnity();
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },
    getItemsType() {
      this.$http
          .get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_FATHER, {
            params: {
              kindFather: 958,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.itemsType = data.info;
            }
          });
    },
    findVehicleType(item) {
      let vehicleType = "Desconocido";
      if (item != undefined) {
        vehicleType = this.itemsType.find(element => element.code === item.code).title;
      }
      return vehicleType;
    },
    newTariff() {
      this.showNewRate = true;
      this.newRate = true;
    },
    edit(row) {
      this.showNewRate = true;
      this.selectedRate = row;
      this.titleRate = "Editar tarifa"
      this.newRate = false;
    },
    cancel() {
      this.showNewRate = false;
      this.selectedRate = null;
    },
    remove(row) {
      confirmation(this, "¿Deseas elminar la tarifa seleccionada?").then((result) => {
        if (!result) {
          return;
        }
        this.deleteTariff(row);
      });
    },
    deleteTariff(tariff) {
      this.isLoading = true;
      this.$http
          .delete(ROUTES.DASHBOARD.RATES.DELETE_RATE, {
            data: {
              tariffCode: tariff.code,
            },
          })
          .then(({data}) => {
            this.isLoading = false;
            if (data.code > 0) {
              this.toast(
                  "La tarifa se ha eliminado correctamente",
                  TOAST_TYPES.SUCCESS
              );
              this.getTariffs();
              return;
            }
            this.toast(data.message, TOAST_TYPES.ERROR);
          });
    },
    formatPrice(price) {
      return formatPrice(price);
    },
    getTariffs() {
      this.showNewRate = false;
      this.$vs.loading()
      this.$http
          .get(ROUTES.DASHBOARD.RATES.GET_RATES_COMPLETE, {
            params: {
              companyId: this.company,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.listRates = data.info;
              return;
            }
            this.listRates = [];
            this.toast("No se han encontrado registros", TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
    },
    removeStyle() {
      this.selectedRate = null;
    },
    /**
     * obtiene la unidad  de tarifa pasadia
     */
    getDayOutUnity() {
      try {
        unityEndpoint.findByInitials(tariffTypes.DAY_OUT).then(data => {
          if (data.code > 0) {
            this.unityDayOut = data.info;
          }
        });
      } catch (error) {
        toast.error(error.message)
      }
    }
  },
};
</script>